import { localStorageKeys } from './constants';

export const getLocalMemberStatus = () => {
    return window.localStorage.getItem(localStorageKeys.SELECTED_MEMBER_STATUS) &&
        JSON.parse(window.localStorage.getItem(localStorageKeys.SELECTED_MEMBER_STATUS)).length > 0
        ? JSON.parse(window.localStorage.getItem(localStorageKeys.SELECTED_MEMBER_STATUS))
        : ['2'];
};
